import { assert, create } from 'superstruct'
import { PaymentMethod, PaymentMethodFilter } from './schema/payment-method.js'

export const createPaymentMethod = (data) => create(data, PaymentMethod)

const createEnabledPredicate =
  (value) =>
  ({ enabled, id }) =>
    (id === value && enabled) || (id !== value && !enabled)

const isPaymentMethodTypeEnabled = (
  paymentMethodTypes,
  { cryptoAsset, currency, orderType, type }
) => {
  if (typeof paymentMethodTypes !== 'object' || paymentMethodTypes === null) {
    throw new TypeError('paymentMethodTypes must be a non-null object')
  }

  const paymentType = paymentMethodTypes[type]
  if (typeof paymentType === 'boolean' || paymentType === undefined) {
    return paymentType ?? true
  }

  if (typeof paymentType !== 'object' || paymentType === null) {
    throw new TypeError(
      `Invalid paymentType for type "${type}". Expected a non-null object or boolean.`
    )
  }

  const isEnabled = paymentType[orderType] ?? paymentType[cryptoAsset] ?? paymentType[currency]
  if (typeof isEnabled === 'boolean') {
    return isEnabled
  }

  return (
    !orderType ||
    (paymentType[cryptoAsset]?.[orderType] ?? paymentType[currency]?.[orderType] ?? true)
  )
}

export const createPaymentMethodValidator =
  ({ assets, paymentMethodTypes, ...input } = Object.create(null)) =>
  (paymentMethod) => {
    const { appId, country, currency, type, cryptoAsset, orderType } = create(
      input,
      PaymentMethodFilter
    )

    assert(paymentMethod, PaymentMethod)

    return (
      (!type ||
        (Array.isArray(paymentMethod.type)
          ? paymentMethod.type.includes(type)
          : type === paymentMethod.type)) &&
      (!country || (paymentMethod.countries || []).every(createEnabledPredicate(country))) &&
      (!currency || (paymentMethod.currencies || []).every(createEnabledPredicate(currency))) &&
      (!cryptoAsset || !assets || Object.values(assets || {}).includes(cryptoAsset)) &&
      (!orderType || !paymentMethod.orderTypes || paymentMethod.orderTypes.includes(orderType)) &&
      (!paymentMethodTypes || isPaymentMethodTypeEnabled(paymentMethodTypes, input)) &&
      (!appId || (paymentMethod.apps || []).every(createEnabledPredicate(appId)))
    )
  }
